import MainPathConstants from '../routes/MainPathConstants';
import InsightsPathConstants from '../routes/InsightsPathConstants';
import PracticeAreasConstants from '../routes/PracticeAreasConstants';
import TeamPathConstants from '../routes/TeamPathConstants';
import CareersPathConstants from '../routes/CareersPathConstants';

export const Documents = [
  {
    url: MainPathConstants.LANDING,
    header:
      'Home. Landing. Committed Legal Advocacy with Tailored Excellence. Dedicated to Conducting Ethical and Sustainable Business Practices. Navigating Egypts Evolving Data Protection Landscape: A Focus on Privacy Compliance',
    text: 'With a seasoned team of professionals, we navigate the complexities of the legal landscape, ensuring steadfast advocacy for your unique needs. In the dynamic realm of data protection, Egypt is set to unveil new regulations that will reshape the landscape and intensify the spotlight on privacy compliance.',
  },
  {
    url: MainPathConstants.CONTACT,
    header: 'Contact Us. Thank you for considering Afifi',
    text: 'For Any Other Questions Or Requests, Kindly Fill Out The Form Below',
  },
  {
    url: MainPathConstants.ABOUT,
    header:
      'About. We Stand as Destination Of Excellence. Founded in 1981, Leading through Excellence',
    text: 'Afifi was founded by Mr. Amal Afifi Dawood in 1981,since then, the firm has developed a reputation of integrity, professionalism, and commitment in delivering the highest quality of broad legal services in the MENA region and Globally. The firms renowned reputation in the Egyptian legal market has led us to enter an association with El Oteifi Law Office then in 1996 we entered into an association with one of the biggest law firms worldwide: Dentons.',
  },
  {
    url: MainPathConstants.DENTONS,
    header: 'Dentons Partnership. Leading Our Impact Globally',
    text: 'Founded in 2013 through the merger of three large law firms, SNR Denton, Fraser Milner Casgrain and Salans, Dentons has grown rapidly through a series of mergers and acquisitions, including its 2015 merger with Chinese law firm Dacheng, which at the time made it the largest law firm in the world by both lawyer count and revenue.',
  },
  {
    url: MainPathConstants.PRACTICE_AREAS,
    header:
      'Main Practice Areas, Practice Area, Shaping The Global Influence Through Our Practice Areas, Communication',
    text: 'We are committed to providing top-tier legal services, upholding the highest standards of professionalism, and fostering a culture of collaborative success. Our dedication to client satisfaction and our pursuit of justice are unwavering, ensuring that we not only meet but exceed expectations in every case we handle. With a forward-thinking approach and a team of expert legal professionals, we are constantly striving to make a meaningful impact in the lives of our clients and the community.',
  },
  {
    url: InsightsPathConstants.MAIN,
    header:
      'Main Insights, Insights, Expert Insight, Personalized Solutions, Generic Insights, Practice Related Insights',
    text: 'At Afifi, we blend deep legal expertise with personalized service. Our team stays ahead of legal trends to offer you innovative, effective solutions for your unique challenges. Choose us for strategic guidance and the confidence that your legal matters are in expert hands',
  },
  {
    url: InsightsPathConstants.LABOR_LAW,
    header:
      'Labor Law Insights, Insights, Expert Insight, Personalized Solutions, Generic Insights, Practice Related Insights',
    text: 'A Balancing Act: Egypt’s New Labor Law Navigates a Complex Landscape',
  },
  {
    url: InsightsPathConstants.RENEWABLE_ENERGY,
    header:
      'Renewable Energy Insights, Insights, Expert Insight, Personalized Solutions, Generic Insights, Practice Related Insights',
    text: 'New A Balancing Act: Egypts New Labor Law Navigates a Complex Landscape',
  },
  {
    url: InsightsPathConstants.DATA_PRIVACY,
    header:
      'Data Privacy Insights, Insights, Expert Insight, Personalized Solutions, Generic Insights, Practice Related Insights',
    text: 'A New Dawn for Data Privacy Unveiling Egypts Evolving Regulatory Landscape',
  },
  {
    url: InsightsPathConstants.SUSTAINABLE_MOBILITY,
    header:
      'Sustainable Mobility Insights, Insights, Expert Insight, Personalized Solutions, Generic Insights, Practice Related Insights',
    text: 'Green Transportation Navigating the Transition to Sustainable Mobility',
  },
  {
    url: InsightsPathConstants.TAXING_CATALYST,
    header:
      'Taxing Catalyst Insights, Insights, Expert Insight, Personalized Solutions, Generic Insights, Practice Related Insights',
    text: 'Taxation and Investment Law: A Taxing Catalyst',
  },
  {
    url: InsightsPathConstants.CAPITAL_RETENTION,
    header:
      'Capital Retention Insights, Insights, Expert Insight, Personalized Solutions, Generic Insights, Practice Related Insights',
    text: 'Egypts New Opportunities Embracing Foreign Currency Capital Retention',
  },
  {
    url: InsightsPathConstants.SUSTAINABLE_FUELS,
    header:
      'Sustainable Fuels Insights, Insights, Expert Insight, Personalized Solutions, Generic Insights, Practice Related Insights',
    text: 'EU Adopts New Law to Decarbonize Aviation Sector with Sustainable Fuels',
  },
  {
    url: InsightsPathConstants.GAFI,
    header:
      'GAFI Insights, Insights, Expert Insight, Personalized Solutions, Generic Insights, Practice Related Insights',
    text: 'GAFI Streamlines Post-Incorporation Services',
  },
  {
    url: InsightsPathConstants.ENERGY_GLOBAL_DEMAND,
    header:
      'Energy Global Demand Insights, Insights, Expert Insight, Personalized Solutions, Generic Insights, Practice Related Insights',
    text: 'Energy Global Demand Navigating the Energy Sea Egypts Strategic Optimization for a Dynamic Global Market',
  },
  {
    url: InsightsPathConstants.ARBITRATION_RESOLVING,
    header:
      'Arbitration Resolving Insights, Insights, Expert Insight, Personalized Solutions, Generic Insights, Practice Related Insights',
    text: 'The Rise of Arbitration Resolving International Finance Disputes with Speed and Expertise',
  },
  {
    url: InsightsPathConstants.CONFERENCE_OF_THE_PARTIES,
    header:
      'Conference of the Parties Insights, COP, COP27, COP28 Insights, Expert Insight, Personalized Solutions, Generic Insights, Practice Related Insights',
    text: 'Navigating the Path to Renewables: Egypt and the UAEs Energy Transition Roadmap at COP27 and COP28',
  },
  {
    url: InsightsPathConstants.CONSTRUCTION_TRENDS,
    header:
      'Construction Trends Insights, Insights, Expert Insight, Personalized Solutions, Generic Insights, Practice Related Insights',
    text: 'Construction Trends in Egypt Charting the Future of Concrete and Steel Emerging Trends and Untapped Potential in Egypts Construction Landscape by 2025',
  },
  {
    url: InsightsPathConstants.CRCICA_RULES,
    header:
      'CRCICA Rules Insights, Insights, Expert Insight, Personalized Solutions, Generic Insights, Practice Related Insights',
    text: 'CRCICA Rules 2024: Advancing International Arbitration',
  },
  {
    url: InsightsPathConstants.HYDROGEN_INITIATIVES,
    header:
      'Hydrogen Initiatives Insights, Insights, Expert Insight, Personalized Solutions, Generic Insights, Practice Related Insights',
    text: 'Legislative Committee Approves Proposed Law on Incentives for Green Hydrogen Initiatives',
  },
  {
    url: InsightsPathConstants.INTERNATIONAL_FINANCE,
    header:
      'International Finance Insights, Insights, Expert Insight, Personalized Solutions, Generic Insights, Practice Related Insights',
    text: 'International Finance A Catalyst for Prosperity International Finance Corporation Injects USD 7 Billion into Egypts Economic Engine',
  },
  {
    url: InsightsPathConstants.LEGAL_PERSPECTIVE,
    header:
      'Legal Perspective Insights, Insights, Expert Insight, Personalized Solutions, Generic Insights, Practice Related Insights',
    text: 'New International Arbitration Centre Launches in Abu Dhabi (ArbitrateAD)',
  },
  {
    url: InsightsPathConstants.MERGER_CONTROL,
    header:
      'Merger Control  Insights, Insights, Expert Insight, Personalized Solutions, Generic Insights, Practice Related Insights',
    text: 'Reshaping the Landscape: Transformative Changes in Egypt’s Merger Control Framework',
  },
  {
    url: InsightsPathConstants.RENEWABLE_ENERGY_FUTURE,
    header:
      'Renewable Energy Future Insights, Insights, Expert Insight, Personalized Solutions, Generic Insights, Practice Related Insights',
    text: 'Green Tide Rising $6 Billion Invests in Egypts Renewable Energy Future with Global Backing',
  },
  {
    url: InsightsPathConstants.TRANSPORTATION_LOGISTICS,
    header:
      'Transportation Logistics Insights, Insights, Expert Insight, Personalized Solutions, Generic Insights, Practice Related Insights',
    text: 'Ascending the Logistics Ladder: Egypts Strategic Transformation into a Global Transport and Logistics Hub by 2024',
  },
  {
    url: CareersPathConstants.CAREERS,
    header: 'Main Careers, Interns, Professionals, Build Your Legal Career',
    text: 'We are proud to offer lawyers and professional staff myriad opportunities to apply their talents toward important, challenging projects on a global stage. We seek motivated individuals who are talented and committed to pursue meaningful work and ensure excellent service to clients.',
  },
  {
    url: CareersPathConstants.INTERNS,
    header: 'Interns Careers, Interns, Form, Build Your Legal Career',
    text: 'Embrace a career path where your potential is recognized and your contributions truly matter. Start your journey with us and become an integral part of a forward-thinking legal team.',
  },
  {
    url: CareersPathConstants.PROFESSIONALS,
    header:
      'Professionals Careers, Professionals, Form, Build Your Legal Career',
    text: 'Our team is on the lookout for driven, talented individuals eager to contribute to our narrative. Whether youre a legal expert, a business professional, or a recent graduate seeking growth and career advancement, explore our current openings and programs to find where you fit in our story',
  },
  {
    url: PracticeAreasConstants.ARBITRATION,
    text: 'Arbitration Practice Area',
  },
  {
    url: PracticeAreasConstants.COMPETITION,
    text: 'Competition Practice Area',
  },
  {
    url: PracticeAreasConstants.CORPORATE_GOVERNANCE,
    text: 'Corporate Governance Practice Area',
  },
  {
    url: PracticeAreasConstants.INTELLECTUAL,
    text: 'Intellectual Property Practice Area',
  },
  {
    url: PracticeAreasConstants.REAL_ESTATE,
    text: 'Real Estate Practice Area',
  },
  {
    url: PracticeAreasConstants.TRANSPORTATION,
    text: 'Transportation Practice Area',
  },
  {
    url: PracticeAreasConstants.AVIATION,
    text: 'Aviation Practice Area',
  },
  {
    url: PracticeAreasConstants.CONSTRUCTION,
    text: 'Construction Practice Area',
  },
  {
    url: PracticeAreasConstants.EMPLOYMENT,
    text: 'Employment Practice Area',
  },
  {
    url: PracticeAreasConstants.WHITE_COLLAR_CRIME,
    text: 'White-collar Crime Practice Area',
  },
  {
    url: PracticeAreasConstants.BANKING_AND_FINANCE,
    text: 'Banking & Finance Practice Area',
  },
  {
    url: PracticeAreasConstants.CORPORATE,
    text: 'Corporate Practice Area',
  },
  {
    url: PracticeAreasConstants.LITIGATION,
    text: 'Litigation Practice Area',
  },
  {
    url: PracticeAreasConstants.ENERGY,
    text: 'Energy Practice Area',
  },
  {
    url: PracticeAreasConstants.OIL_AND_GAS,
    text: 'Oil & Gas Practice Area',
  },
  {
    url: PracticeAreasConstants.TECHNOLOGY,
    text: 'Technology Practice Area',
  },
  {
    url: PracticeAreasConstants.JOIN_VENTURES,
    text: 'Join Ventures Practice Area',
  },
  {
    url: PracticeAreasConstants.MERGER_AND_ACQUISITION,
    text: 'Merger & Acquisition Practice Area',
  },
  {
    url: PracticeAreasConstants.RENEWABLE_ENERGY,
    text: 'Renewable Energy Practice Area',
  },
  // Add the rest of the PracticeAreasConstants here
  {
    url: TeamPathConstants.MAIN,
    header:
      'Team Main, Professionals, Meet Our Legal Pioneers, Our Professionals',
    text: '',
  },
  {
    url: TeamPathConstants.MAIN,
    header: 'Main Team',
    text: 'Main for the team',
  },
  {
    url: TeamPathConstants.HABIL_ABU_EL_KHEIR,
    header: 'Habil Abu El Kheir Team Profile',
    text: 'Managing Associate, LLB',
  },
  {
    url: TeamPathConstants.TAMER_KAMAL,
    header: 'Tamer Kamal Team Profile',
    text: 'Managing Associate, LLB',
  },
  {
    url: TeamPathConstants.MOHAMED_TAYEL,
    header: 'Mohamed Tayel Team Profile',
    text: 'Managing Associate, LLB, LLM',
  },
  {
    url: TeamPathConstants.HOSSAM_EL_SHARAWI,
    header: 'Hossam El Sharawi Team Profile',
    text: 'Managing Associate',
  },
  {
    url: TeamPathConstants.GAMIL_DORGHAM,
    header: 'Gamil Dorgham Team Profile',
    text: 'Senior Associate',
  },
  {
    url: TeamPathConstants.MAHMOUD_MAHER,
    header: 'Mahmoud Maher Team Profile',
    text: 'Junior Associate, LLB, LLM',
  },
  {
    url: TeamPathConstants.ADEL_FEKRY,
    header: 'Adel Fekry Team Profile',
    text: 'Accountant',
  },
  {
    url: TeamPathConstants.ALIA_SAFEI,
    header: 'Alia Safei Team Profile',
    text: 'Junior Associate, LLB, LLM',
  },
  {
    url: TeamPathConstants.ANDREW_AFIFI,
    header: 'Andrew Afifi Team Profile',
    text: 'Associate, LLB, LLM, J.D Juris Doctor',
  },
  {
    url: TeamPathConstants.ASSER_NEGM_EL_DIN,
    header: 'Asser Negm El Din Team Profile',
    text: 'Junior Associate, LLB, LLM',
  },
  {
    url: TeamPathConstants.EMIL_GHOBRIAL,
    header: 'Emil Ghobrial Team Profile',
    text: 'Senior Associate, LLB',
  },
  {
    url: TeamPathConstants.AMIN_KAMAL_AMIN,
    header: 'Amin Kamal Amin Team Profile',
    text: 'Senior Associate',
  },
  {
    url: TeamPathConstants.WALID_SAKR,
    header: 'Walid Sakr Team Profile',
    text: 'Team Profile for Walid Sakr',
  },
  {
    url: TeamPathConstants.ADEL_RASHEED,
    header: 'Adel Rasheed Team Profile',
    text: 'Of Counsel',
  },
  {
    url: TeamPathConstants.EMIL_LABIB_HANA,
    header: 'Emil Labib Hana Team Profile',
    text: 'Of Counsel',
  },
  {
    url: TeamPathConstants.GAMAL_ABDEL_RAZAK,
    header: 'Gamal Abdel Razak Team Profile',
    text: 'Of Counsel',
  },
  {
    url: TeamPathConstants.HANY_EDWARD,
    header: 'Hany Edward Team Profile',
    text: 'Of Counsel',
  },
  {
    url: TeamPathConstants.NANCY_NASHAT,
    header: 'Nancy Nashat Team Profile',
    text: 'Office Manager',
  },
  {
    url: TeamPathConstants.MARY_RIZKALLA,
    header: 'Mary Rizkalla Team Profile',
    text: 'Legal Secretary',
  },
  {
    url: TeamPathConstants.BESHOY_MELAD,
    header: 'Beshoy Melad Team Profile',
    text: 'Accountant',
  },
  {
    url: TeamPathConstants.FADY_SEIF,
    header: 'Fady Seif Team Profile',
    text: 'Senior Associate',
  },
  {
    url: TeamPathConstants.AHMED_RASHEED,
    header: 'Ahmed Rasheed Team Profile, Ahmad Rashed',
    text: 'Managing Associate',
  },
  {
    url: TeamPathConstants.ABANOUB_THARWAT,
    header: 'Abanoub Tharwat Team Profile',
    text: 'Junior Associate',
  },
  {
    url: TeamPathConstants.MAHROUS_SHAFIK,
    header: 'Mahrous Shafik Team Profile',
    text: 'Real Estate Consultant',
  },
  {
    url: TeamPathConstants.AMAL_AFIFI,
    header: 'Amal Afifi Team Profile',
    text: 'Founding and Managing Partner',
  },
  {
    url: TeamPathConstants.AYMAN_ELSISI,
    header: 'Ayman Elsisi Team Profile',
    text: 'Government Relations Specialist',
  },
  {
    url: TeamPathConstants.HABIBA_OSAMA,
    header: 'Habiba Osama Team Profile',
    text: 'Junior Associate',
  },
];

